import { Capacitor } from '@capacitor/core';
import { SafeArea } from '@capacitor-community/safe-area';
import Clarity from '@microsoft/clarity';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  DeepLinkProvider,
  KycProvider,
  SessionProvider,
  MixpanelProvider,
  SnapshotNavigationProvider,
} from 'context';
import { environment } from 'utils/environmentVariables';
import App from './App';

import './index.css';

// Initialize Clarity
if (environment.REACT_APP_CLARITY_ID && !Capacitor.isNativePlatform()) {
  Clarity.init(environment.REACT_APP_CLARITY_ID);
}

void SafeArea.enable({
  config: {
    customColorsForSystemBars: true,
    statusBarColor: '#00000000', // transparent
    statusBarContent: 'dark',
    navigationBarColor: '#00000000', // transparent
    navigationBarContent: 'dark',
  },
});

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <SnapshotNavigationProvider>
      <SessionProvider>
        <DeepLinkProvider>
          <KycProvider>
            <MixpanelProvider name="global-app-mixpanel-instance">
              <App />
            </MixpanelProvider>
          </KycProvider>
        </DeepLinkProvider>
      </SessionProvider>
    </SnapshotNavigationProvider>
  </BrowserRouter>
  // </React.StrictMode>
);
